export const DEFAULT_CATALOG = [
  {
    "id": "homeassistant",
    "title": "Home Assistant",
    "category": "smarthome",
    "url": "https://my.home-assistant.io",
    "customFullscreenUrl": "",
    "icon": "home",
    "brandSlug": "homeassistant",
    "customLogoUrl": "/logos/square/dark/homeassistant.png",
    "wideLogoUrl": "/logos/banner/dark/homeassistant.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "immich",
    "title": "Immich",
    "category": "smarthome",
    "url": "https://immich.app",
    "customFullscreenUrl": "",
    "icon": "image",
    "brandSlug": "immich",
    "customLogoUrl": "/logos/square/dark/immich.png",
    "wideLogoUrl": "/logos/banner/dark/immich.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "solaredge",
    "title": "SolarEdge",
    "category": "smarthome",
    "url": "https://monitoring.solaredge.com",
    "customFullscreenUrl": "",
    "icon": "zap",
    "brandSlug": "solaredge",
    "customLogoUrl": "/logos/square/dark/solaredge.png",
    "wideLogoUrl": "/logos/banner/dark/solaredge.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "shelly",
    "title": "Shelly",
    "category": "smarthome",
    "url": "https://control.shelly.cloud",
    "customFullscreenUrl": "",
    "icon": "cpu",
    "brandSlug": "shelly",
    "customLogoUrl": "/logos/square/dark/shelly.png",
    "wideLogoUrl": "/logos/banner/dark/shelly.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "homebridge",
    "title": "Homebridge",
    "category": "smarthome",
    "url": "http://homebridge.local:8581",
    "customFullscreenUrl": "",
    "icon": "home",
    "brandSlug": "homebridge",
    "customLogoUrl": "/logos/square/dark/homebridge.png",
    "wideLogoUrl": "/logos/banner/dark/homebridge.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "portainer",
    "title": "Portainer",
    "category": "smarthome",
    "url": "http://localhost:9000",
    "customFullscreenUrl": "",
    "icon": "server",
    "brandSlug": "portainer",
    "customLogoUrl": "/logos/square/dark/portainer.png",
    "wideLogoUrl": "/logos/banner/dark/portainer.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "pihole",
    "title": "Pi-hole",
    "category": "smarthome",
    "url": "http://pi.hole/admin",
    "customFullscreenUrl": "",
    "icon": "shield",
    "brandSlug": "pihole",
    "customLogoUrl": "/logos/square/dark/pihole.png",
    "wideLogoUrl": "/logos/banner/dark/pihole.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "adguard",
    "title": "AdGuard Home",
    "category": "smarthome",
    "url": "http://localhost:3000",
    "customFullscreenUrl": "",
    "icon": "shield-check",
    "brandSlug": "adguard",
    "customLogoUrl": "/logos/square/dark/adguard.png",
    "wideLogoUrl": "/logos/banner/dark/adguard.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "zigbee2mqtt",
    "title": "Zigbee2MQTT",
    "category": "smarthome",
    "url": "http://localhost:8080",
    "customFullscreenUrl": "",
    "icon": "radio",
    "brandSlug": "zigbee2mqtt",
    "customLogoUrl": "/logos/square/dark/zigbee2mqtt.png",
    "wideLogoUrl": "/logos/banner/dark/zigbee2mqtt.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "esphome",
    "title": "ESPHome",
    "category": "smarthome",
    "url": "http://localhost:6052",
    "customFullscreenUrl": "",
    "icon": "cpu",
    "brandSlug": "esphome",
    "customLogoUrl": "/logos/square/dark/esphome.png",
    "wideLogoUrl": "/logos/banner/dark/esphome.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "nodered",
    "title": "Node-RED",
    "category": "smarthome",
    "url": "http://localhost:1880",
    "customFullscreenUrl": "",
    "icon": "workflow",
    "brandSlug": "nodered",
    "customLogoUrl": "/logos/square/dark/nodered.png",
    "wideLogoUrl": "/logos/banner/dark/nodered.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "octoprint",
    "title": "OctoPrint",
    "category": "smarthome",
    "url": "http://octopi.local",
    "customFullscreenUrl": "",
    "icon": "printer",
    "brandSlug": "octoprint",
    "customLogoUrl": "/logos/square/dark/octoprint.png",
    "wideLogoUrl": "/logos/banner/dark/octoprint.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "homepage",
    "title": "Homepage",
    "category": "smarthome",
    "url": "http://localhost:3000",
    "customFullscreenUrl": "",
    "icon": "layout-dashboard",
    "brandSlug": "homepage",
    "customLogoUrl": "/logos/square/dark/homepage.png",
    "wideLogoUrl": "/logos/banner/dark/homepage.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "paperless",
    "title": "Paperless-ngx",
    "category": "smarthome",
    "url": "http://localhost:8000",
    "customFullscreenUrl": "",
    "icon": "file-text",
    "brandSlug": "paperless",
    "customLogoUrl": "/logos/square/dark/paperless.png",
    "wideLogoUrl": "/logos/banner/dark/paperless.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "tasmoadmin",
    "title": "TasmoAdmin",
    "category": "smarthome",
    "url": "http://localhost:8001",
    "customFullscreenUrl": "",
    "icon": "sliders",
    "brandSlug": "tasmoadmin",
    "customLogoUrl": "/logos/square/dark/tasmoadmin.png",
    "wideLogoUrl": "/logos/banner/dark/tasmoadmin.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "facebook",
    "title": "Facebook",
    "category": "social",
    "url": "https://www.facebook.com",
    "customFullscreenUrl": "",
    "icon": "facebook",
    "brandSlug": "facebook",
    "customLogoUrl": "/logos/square/dark/facebook.png",
    "wideLogoUrl": "/logos/banner/dark/facebook.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "reddit",
    "title": "Reddit",
    "category": "social",
    "url": "https://www.reddit.com",
    "customFullscreenUrl": "",
    "icon": "message-square",
    "brandSlug": "reddit",
    "customLogoUrl": "/logos/square/dark/reddit.png",
    "wideLogoUrl": "/logos/banner/dark/reddit.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "instagram",
    "title": "Instagram",
    "category": "social",
    "url": "https://www.instagram.com",
    "customFullscreenUrl": "",
    "icon": "instagram",
    "brandSlug": "instagram",
    "customLogoUrl": "/logos/square/dark/instagram.png",
    "wideLogoUrl": "/logos/banner/dark/instagram.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "twitter",
    "title": "Twitter / X",
    "category": "social",
    "url": "https://x.com",
    "customFullscreenUrl": "",
    "icon": "twitter",
    "brandSlug": "twitter",
    "customLogoUrl": "/logos/square/dark/twitter.png",
    "wideLogoUrl": "/logos/banner/dark/twitter.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "whatsapp",
    "title": "WhatsApp",
    "category": "social",
    "url": "https://web.whatsapp.com",
    "customFullscreenUrl": "",
    "icon": "message-circle",
    "brandSlug": "whatsapp",
    "customLogoUrl": "/logos/square/dark/whatsapp.png",
    "wideLogoUrl": "/logos/banner/dark/whatsapp.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "telegram",
    "title": "Telegram",
    "category": "social",
    "url": "https://web.telegram.org",
    "customFullscreenUrl": "",
    "icon": "send",
    "brandSlug": "telegram",
    "customLogoUrl": "/logos/square/dark/telegram.png",
    "wideLogoUrl": "/logos/banner/dark/telegram.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "threads",
    "title": "Threads",
    "category": "social",
    "url": "https://www.threads.net",
    "customFullscreenUrl": "",
    "icon": "at-sign",
    "brandSlug": "threads",
    "customLogoUrl": "/logos/square/dark/threads.png",
    "wideLogoUrl": "/logos/banner/dark/threads.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "linkedin",
    "title": "LinkedIn",
    "category": "social",
    "url": "https://www.linkedin.com",
    "customFullscreenUrl": "",
    "icon": "linkedin",
    "brandSlug": "linkedin",
    "customLogoUrl": "/logos/square/dark/linkedin.png",
    "wideLogoUrl": "/logos/banner/dark/linkedin.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "tiktok",
    "title": "TikTok",
    "category": "social",
    "url": "https://www.tiktok.com",
    "customFullscreenUrl": "",
    "icon": "video",
    "brandSlug": "tiktok",
    "customLogoUrl": "/logos/square/dark/tiktok.png",
    "wideLogoUrl": "/logos/banner/dark/tiktok.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "discord",
    "title": "Discord",
    "category": "social",
    "url": "https://discord.com/app",
    "customFullscreenUrl": "",
    "icon": "message-square",
    "brandSlug": "discord",
    "customLogoUrl": "/logos/square/dark/discord.png",
    "wideLogoUrl": "/logos/banner/dark/discord.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "mastodon",
    "title": "Mastodon",
    "category": "social",
    "url": "https://mastodon.social",
    "customFullscreenUrl": "",
    "icon": "share-2",
    "brandSlug": "mastodon",
    "customLogoUrl": "/logos/square/dark/mastodon.png",
    "wideLogoUrl": "/logos/banner/dark/mastodon.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "bluesky",
    "title": "Bluesky",
    "category": "social",
    "url": "https://bsky.app",
    "customFullscreenUrl": "",
    "icon": "cloud",
    "brandSlug": "bluesky",
    "customLogoUrl": "/logos/square/dark/bluesky.png",
    "wideLogoUrl": "/logos/banner/dark/bluesky.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "lemmy",
    "title": "Lemmy",
    "category": "social",
    "url": "https://lemmy.ml",
    "customFullscreenUrl": "",
    "icon": "message-square",
    "brandSlug": "lemmy",
    "customLogoUrl": "/logos/square/dark/lemmy.png",
    "wideLogoUrl": "/logos/banner/dark/lemmy.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "pinterest",
    "title": "Pinterest",
    "category": "social",
    "url": "https://www.pinterest.com",
    "customFullscreenUrl": "",
    "icon": "image",
    "brandSlug": "pinterest",
    "customLogoUrl": "/logos/square/dark/pinterest.png",
    "wideLogoUrl": "/logos/banner/dark/pinterest.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "element",
    "title": "Element / Matrix",
    "category": "social",
    "url": "https://app.element.io",
    "customFullscreenUrl": "",
    "icon": "message-square",
    "brandSlug": "element",
    "customLogoUrl": "/logos/square/dark/element.png",
    "wideLogoUrl": "/logos/banner/dark/element.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "snapchat",
    "title": "Snapchat",
    "category": "social",
    "url": "https://web.snapchat.com",
    "customFullscreenUrl": "",
    "icon": "ghost",
    "brandSlug": "snapchat",
    "customLogoUrl": "/logos/square/dark/snapchat.png",
    "wideLogoUrl": "/logos/banner/dark/snapchat.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "youtube",
    "title": "YouTube",
    "category": "streaming",
    "url": "https://www.youtube.com",
    "customFullscreenUrl": "https://www.youtube.com",
    "icon": "youtube",
    "brandSlug": "youtube",
    "customLogoUrl": "/logos/square/dark/youtube.png",
    "wideLogoUrl": "/logos/banner/dark/youtube.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "netflix",
    "title": "Netflix",
    "category": "streaming",
    "url": "https://www.netflix.com",
    "customFullscreenUrl": "",
    "icon": "tv",
    "brandSlug": "netflix",
    "customLogoUrl": "/logos/square/dark/netflix.png",
    "wideLogoUrl": "/logos/banner/dark/netflix.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "disneyplus",
    "title": "Disney+",
    "category": "streaming",
    "url": "https://www.disneyplus.com",
    "customFullscreenUrl": "",
    "icon": "film",
    "brandSlug": "disneyplus",
    "customLogoUrl": "/logos/square/dark/disneyplus.png",
    "wideLogoUrl": "/logos/banner/dark/disneyplus.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "primevideo",
    "title": "Prime Video",
    "category": "streaming",
    "url": "https://www.primevideo.com",
    "customFullscreenUrl": "",
    "icon": "video",
    "brandSlug": "primevideo",
    "customLogoUrl": "/logos/square/dark/primevideo.png",
    "wideLogoUrl": "/logos/banner/dark/primevideo.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "twitch",
    "title": "Twitch",
    "category": "streaming",
    "url": "https://www.twitch.tv",
    "customFullscreenUrl": "",
    "icon": "twitch",
    "brandSlug": "twitch",
    "customLogoUrl": "/logos/square/dark/twitch.png",
    "wideLogoUrl": "/logos/banner/dark/twitch.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "plex",
    "title": "Plex",
    "category": "streaming",
    "url": "https://app.plex.tv",
    "customFullscreenUrl": "",
    "icon": "server",
    "brandSlug": "plex",
    "customLogoUrl": "/logos/square/dark/plex.png",
    "wideLogoUrl": "/logos/banner/dark/plex.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "spotify",
    "title": "Spotify",
    "category": "streaming",
    "url": "https://open.spotify.com",
    "customFullscreenUrl": "",
    "icon": "music",
    "brandSlug": "spotify",
    "customLogoUrl": "/logos/square/dark/spotify.png",
    "wideLogoUrl": "/logos/banner/dark/spotify.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "applemusic",
    "title": "Apple Music",
    "category": "streaming",
    "url": "https://music.apple.com",
    "customFullscreenUrl": "",
    "icon": "disc",
    "brandSlug": "applemusic",
    "customLogoUrl": "/logos/square/dark/applemusic.png",
    "wideLogoUrl": "/logos/banner/dark/applemusic.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "paramountplus",
    "title": "Paramount+",
    "category": "streaming",
    "url": "https://www.paramountplus.com",
    "customFullscreenUrl": "",
    "icon": "film",
    "brandSlug": "paramountplus",
    "customLogoUrl": "/logos/square/dark/paramountplus.png",
    "wideLogoUrl": "/logos/banner/dark/paramountplus.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "max",
    "title": "Max",
    "category": "streaming",
    "url": "https://www.max.com",
    "customFullscreenUrl": "",
    "icon": "tv",
    "brandSlug": "max",
    "customLogoUrl": "/logos/square/dark/max.png",
    "wideLogoUrl": "/logos/banner/dark/max.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "crunchyroll",
    "title": "Crunchyroll",
    "category": "streaming",
    "url": "https://www.crunchyroll.com",
    "customFullscreenUrl": "",
    "icon": "tv",
    "brandSlug": "crunchyroll",
    "customLogoUrl": "/logos/square/dark/crunchyroll.png",
    "wideLogoUrl": "/logos/banner/dark/crunchyroll.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "ytmusic",
    "title": "YouTube Music",
    "category": "streaming",
    "url": "https://music.youtube.com",
    "customFullscreenUrl": "",
    "icon": "music",
    "brandSlug": "ytmusic",
    "customLogoUrl": "/logos/square/dark/ytmusic.png",
    "wideLogoUrl": "/logos/banner/dark/ytmusic.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "deezer",
    "title": "Deezer",
    "category": "streaming",
    "url": "https://www.deezer.com",
    "customFullscreenUrl": "",
    "icon": "music",
    "brandSlug": "deezer",
    "customLogoUrl": "/logos/square/dark/deezer.png",
    "wideLogoUrl": "/logos/banner/dark/deezer.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "soundcloud",
    "title": "SoundCloud",
    "category": "streaming",
    "url": "https://soundcloud.com",
    "customFullscreenUrl": "",
    "icon": "radio",
    "brandSlug": "soundcloud",
    "customLogoUrl": "/logos/square/dark/soundcloud.png",
    "wideLogoUrl": "/logos/banner/dark/soundcloud.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "dazn",
    "title": "DAZN",
    "category": "streaming",
    "url": "https://www.dazn.com",
    "customFullscreenUrl": "",
    "icon": "tv",
    "brandSlug": "dazn",
    "customLogoUrl": "/logos/square/dark/dazn.png",
    "wideLogoUrl": "/logos/banner/dark/dazn.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "jellyfin",
    "title": "Jellyfin",
    "category": "streaming",
    "url": "http://localhost:8096",
    "customFullscreenUrl": "",
    "icon": "server",
    "brandSlug": "jellyfin",
    "customLogoUrl": "/logos/square/dark/jellyfin.png",
    "wideLogoUrl": "/logos/banner/dark/jellyfin.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "navidrome",
    "title": "Navidrome",
    "category": "streaming",
    "url": "http://localhost:4533",
    "customFullscreenUrl": "",
    "icon": "music",
    "brandSlug": "navidrome",
    "customLogoUrl": "/logos/square/dark/navidrome.png",
    "wideLogoUrl": "/logos/banner/dark/navidrome.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "audiobookshelf",
    "title": "Audiobookshelf",
    "category": "streaming",
    "url": "http://localhost:13378",
    "customFullscreenUrl": "",
    "icon": "book-open",
    "brandSlug": "audiobookshelf",
    "customLogoUrl": "/logos/square/dark/audiobookshelf.png",
    "wideLogoUrl": "/logos/banner/dark/audiobookshelf.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "emby",
    "title": "Emby",
    "category": "streaming",
    "url": "http://localhost:8096",
    "customFullscreenUrl": "",
    "icon": "play-circle",
    "brandSlug": "emby",
    "customLogoUrl": "/logos/square/dark/emby.png",
    "wideLogoUrl": "/logos/banner/dark/emby.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "tidal",
    "title": "Tidal",
    "category": "streaming",
    "url": "https://listen.tidal.com",
    "customFullscreenUrl": "",
    "icon": "music",
    "brandSlug": "tidal",
    "customLogoUrl": "/logos/square/dark/tidal.png",
    "wideLogoUrl": "/logos/banner/dark/tidal.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "kick",
    "title": "Kick",
    "category": "streaming",
    "url": "https://kick.com",
    "customFullscreenUrl": "",
    "icon": "video",
    "brandSlug": "kick",
    "customLogoUrl": "/logos/square/dark/kick.png",
    "wideLogoUrl": "/logos/banner/dark/kick.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "vimeo",
    "title": "Vimeo",
    "category": "streaming",
    "url": "https://vimeo.com",
    "customFullscreenUrl": "",
    "icon": "video",
    "brandSlug": "vimeo",
    "customLogoUrl": "/logos/square/dark/vimeo.png",
    "wideLogoUrl": "/logos/banner/dark/vimeo.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "plutotv",
    "title": "Pluto TV",
    "category": "livetv",
    "url": "https://pluto.tv",
    "customFullscreenUrl": "",
    "icon": "tv",
    "brandSlug": "plutotv",
    "customLogoUrl": "/logos/square/dark/plutotv.png",
    "wideLogoUrl": "/logos/banner/dark/plutotv.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "raiplay",
    "title": "RaiPlay",
    "category": "livetv",
    "url": "https://www.raiplay.it",
    "customFullscreenUrl": "",
    "icon": "tv",
    "brandSlug": "raiplay",
    "customLogoUrl": "/logos/square/dark/raiplay.png",
    "wideLogoUrl": "/logos/banner/dark/raiplay.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "mediaset",
    "title": "Mediaset Infinity",
    "category": "livetv",
    "url": "https://mediasetinfinity.mediaset.it",
    "customFullscreenUrl": "",
    "icon": "tv",
    "brandSlug": "mediaset",
    "customLogoUrl": "/logos/square/dark/mediaset.png",
    "wideLogoUrl": "/logos/banner/dark/mediaset.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "discoveryplus",
    "title": "Discovery+",
    "category": "livetv",
    "url": "https://www.discoveryplus.com",
    "customFullscreenUrl": "",
    "icon": "tv",
    "brandSlug": "discoveryplus",
    "customLogoUrl": "/logos/square/dark/discoveryplus.png",
    "wideLogoUrl": "/logos/banner/dark/discoveryplus.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "rakutentv",
    "title": "Rakuten TV",
    "category": "livetv",
    "url": "https://www.rakuten.tv",
    "customFullscreenUrl": "",
    "icon": "tv",
    "brandSlug": "rakutentv",
    "customLogoUrl": "/logos/square/dark/rakutentv.png",
    "wideLogoUrl": "/logos/banner/dark/rakutentv.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "iptvorg",
    "title": "IPTV Web Player",
    "category": "livetv",
    "url": "https://iptv-org.github.io",
    "customFullscreenUrl": "",
    "icon": "tv",
    "brandSlug": "iptvorg",
    "customLogoUrl": "/logos/square/dark/iptvorg.png",
    "wideLogoUrl": "/logos/banner/dark/iptvorg.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "samsungtv",
    "title": "Samsung TV Plus",
    "category": "livetv",
    "url": "https://www.samsungtvplus.com",
    "customFullscreenUrl": "",
    "icon": "tv",
    "brandSlug": "samsungtv",
    "customLogoUrl": "/logos/square/dark/samsungtv.png",
    "wideLogoUrl": "/logos/banner/dark/samsungtv.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "tubi",
    "title": "Tubi TV",
    "category": "livetv",
    "url": "https://tubitv.com",
    "customFullscreenUrl": "",
    "icon": "tv",
    "brandSlug": "tubi",
    "customLogoUrl": "/logos/square/dark/tubi.png",
    "wideLogoUrl": "/logos/banner/dark/tubi.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "zattoo",
    "title": "Zattoo",
    "category": "livetv",
    "url": "https://zattoo.com",
    "customFullscreenUrl": "",
    "icon": "tv",
    "brandSlug": "zattoo",
    "customLogoUrl": "/logos/square/dark/zattoo.png",
    "wideLogoUrl": "/logos/banner/dark/zattoo.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "abrp",
    "title": "ABRP (A Better Routeplanner)",
    "category": "auto",
    "url": "https://abetterrouteplanner.com",
    "customFullscreenUrl": "",
    "icon": "navigation",
    "brandSlug": "abrp",
    "customLogoUrl": "/logos/square/dark/abrp.png",
    "wideLogoUrl": "/logos/banner/dark/abrp.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "waze",
    "title": "Waze Live Map",
    "category": "auto",
    "url": "https://www.waze.com/live-map",
    "customFullscreenUrl": "",
    "icon": "map-pin",
    "brandSlug": "waze",
    "customLogoUrl": "/logos/square/dark/waze.png",
    "wideLogoUrl": "/logos/banner/dark/waze.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "googlemaps",
    "title": "Google Maps",
    "category": "auto",
    "url": "https://maps.google.com",
    "customFullscreenUrl": "",
    "icon": "map",
    "brandSlug": "googlemaps",
    "customLogoUrl": "/logos/square/dark/googlemaps.png",
    "wideLogoUrl": "/logos/banner/dark/googlemaps.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "chargemap",
    "title": "Chargemap",
    "category": "auto",
    "url": "https://chargemap.com",
    "customFullscreenUrl": "",
    "icon": "zap",
    "brandSlug": "chargemap",
    "customLogoUrl": "/logos/square/dark/chargemap.png",
    "wideLogoUrl": "/logos/banner/dark/chargemap.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "plugshare",
    "title": "PlugShare",
    "category": "auto",
    "url": "https://www.plugshare.com",
    "customFullscreenUrl": "",
    "icon": "zap",
    "brandSlug": "plugshare",
    "customLogoUrl": "/logos/square/dark/plugshare.png",
    "wideLogoUrl": "/logos/banner/dark/plugshare.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "ionity",
    "title": "IONITY",
    "category": "auto",
    "url": "https://ionity.eu",
    "customFullscreenUrl": "",
    "icon": "zap",
    "brandSlug": "ionity",
    "customLogoUrl": "/logos/square/dark/ionity.png",
    "wideLogoUrl": "/logos/banner/dark/ionity.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "enelxway",
    "title": "Enel X Way",
    "category": "auto",
    "url": "https://www.enelxway.com",
    "customFullscreenUrl": "",
    "icon": "zap",
    "brandSlug": "enelxway",
    "customLogoUrl": "/logos/square/dark/enelxway.png",
    "wideLogoUrl": "/logos/banner/dark/enelxway.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "supercharge",
    "title": "Supercharge.info",
    "category": "auto",
    "url": "https://supercharge.info",
    "customFullscreenUrl": "",
    "icon": "map-pin",
    "brandSlug": "supercharge",
    "customLogoUrl": "/logos/square/dark/supercharge.png",
    "wideLogoUrl": "/logos/banner/dark/supercharge.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "teslamate",
    "title": "TeslaMate",
    "category": "auto",
    "url": "http://localhost:4000",
    "customFullscreenUrl": "",
    "icon": "gauge",
    "brandSlug": "teslamate",
    "customLogoUrl": "/logos/square/dark/teslamate.png",
    "wideLogoUrl": "/logos/banner/dark/teslamate.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "teslalogger",
    "title": "TeslaLogger",
    "category": "auto",
    "url": "http://localhost:8888",
    "customFullscreenUrl": "",
    "icon": "activity",
    "brandSlug": "teslalogger",
    "customLogoUrl": "/logos/square/dark/teslalogger.png",
    "wideLogoUrl": "/logos/banner/dark/teslalogger.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "openchargemap",
    "title": "Open Charge Map",
    "category": "auto",
    "url": "https://openchargemap.org",
    "customFullscreenUrl": "",
    "icon": "zap",
    "brandSlug": "openchargemap",
    "customLogoUrl": "/logos/square/dark/openchargemap.png",
    "wideLogoUrl": "/logos/banner/dark/openchargemap.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "openstreetmap",
    "title": "OpenStreetMap",
    "category": "auto",
    "url": "https://www.openstreetmap.org",
    "customFullscreenUrl": "",
    "icon": "map",
    "brandSlug": "openstreetmap",
    "customLogoUrl": "/logos/square/dark/openstreetmap.png",
    "wideLogoUrl": "/logos/banner/dark/openstreetmap.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "electrifyamerica",
    "title": "Electrify America",
    "category": "auto",
    "url": "https://www.electrifyamerica.com",
    "customFullscreenUrl": "",
    "icon": "zap",
    "brandSlug": "electrifyamerica",
    "customLogoUrl": "/logos/square/dark/electrifyamerica.png",
    "wideLogoUrl": "/logos/banner/dark/electrifyamerica.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "herewego",
    "title": "HERE WeGo",
    "category": "auto",
    "url": "https://wego.here.com",
    "customFullscreenUrl": "",
    "icon": "navigation",
    "brandSlug": "herewego",
    "customLogoUrl": "/logos/square/dark/herewego.png",
    "wideLogoUrl": "/logos/banner/dark/herewego.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "chatgpt",
    "title": "ChatGPT",
    "category": "utilities",
    "url": "https://chatgpt.com",
    "customFullscreenUrl": "",
    "icon": "bot",
    "brandSlug": "chatgpt",
    "customLogoUrl": "/logos/square/dark/chatgpt.png",
    "wideLogoUrl": "/logos/banner/dark/chatgpt.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "wikipedia",
    "title": "Wikipedia",
    "category": "utilities",
    "url": "https://it.wikipedia.org",
    "customFullscreenUrl": "",
    "icon": "book-open",
    "brandSlug": "wikipedia",
    "customLogoUrl": "/logos/square/dark/wikipedia.png",
    "wideLogoUrl": "/logos/banner/dark/wikipedia.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "claude",
    "title": "Claude AI",
    "category": "utilities",
    "url": "https://claude.ai",
    "customFullscreenUrl": "",
    "icon": "bot",
    "brandSlug": "claude",
    "customLogoUrl": "/logos/square/dark/claude.png",
    "wideLogoUrl": "/logos/banner/dark/claude.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "google",
    "title": "Google",
    "category": "utilities",
    "url": "https://www.google.com",
    "customFullscreenUrl": "",
    "icon": "search",
    "brandSlug": "google",
    "customLogoUrl": "/logos/square/dark/google.png",
    "wideLogoUrl": "/logos/banner/dark/google.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "weather",
    "title": "AccuWeather",
    "category": "utilities",
    "url": "https://www.accuweather.com",
    "customFullscreenUrl": "",
    "icon": "cloud-sun",
    "brandSlug": "weather",
    "customLogoUrl": "/logos/square/dark/weather.png",
    "wideLogoUrl": "/logos/banner/dark/weather.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "speedtest",
    "title": "Speedtest",
    "category": "utilities",
    "url": "https://www.speedtest.net",
    "customFullscreenUrl": "",
    "icon": "gauge",
    "brandSlug": "speedtest",
    "customLogoUrl": "/logos/square/dark/speedtest.png",
    "wideLogoUrl": "/logos/banner/dark/speedtest.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "notion",
    "title": "Notion",
    "category": "utilities",
    "url": "https://www.notion.so",
    "customFullscreenUrl": "",
    "icon": "file-text",
    "brandSlug": "notion",
    "customLogoUrl": "/logos/square/dark/notion.png",
    "wideLogoUrl": "/logos/banner/dark/notion.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "github",
    "title": "GitHub",
    "category": "utilities",
    "url": "https://github.com",
    "customFullscreenUrl": "",
    "icon": "github",
    "brandSlug": "github",
    "customLogoUrl": "/logos/square/dark/github.png",
    "wideLogoUrl": "/logos/banner/dark/github.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "openwebui",
    "title": "Open WebUI",
    "category": "utilities",
    "url": "http://localhost:3000",
    "customFullscreenUrl": "",
    "icon": "bot",
    "brandSlug": "openwebui",
    "customLogoUrl": "/logos/square/dark/openwebui.png",
    "wideLogoUrl": "/logos/banner/dark/openwebui.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "n8n",
    "title": "n8n",
    "category": "utilities",
    "url": "http://localhost:5678",
    "customFullscreenUrl": "",
    "icon": "workflow",
    "brandSlug": "n8n",
    "customLogoUrl": "/logos/square/dark/n8n.png",
    "wideLogoUrl": "/logos/banner/dark/n8n.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "excalidraw",
    "title": "Excalidraw",
    "category": "utilities",
    "url": "https://excalidraw.com",
    "customFullscreenUrl": "",
    "icon": "edit-3",
    "brandSlug": "excalidraw",
    "customLogoUrl": "/logos/square/dark/excalidraw.png",
    "wideLogoUrl": "/logos/banner/dark/excalidraw.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "cyberchef",
    "title": "CyberChef",
    "category": "utilities",
    "url": "https://gchq.github.io/CyberChef",
    "customFullscreenUrl": "",
    "icon": "terminal",
    "brandSlug": "cyberchef",
    "customLogoUrl": "/logos/square/dark/cyberchef.png",
    "wideLogoUrl": "/logos/banner/dark/cyberchef.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "gemini",
    "title": "Google Gemini",
    "category": "utilities",
    "url": "https://gemini.google.com",
    "customFullscreenUrl": "",
    "icon": "sparkles",
    "brandSlug": "gemini",
    "customLogoUrl": "/logos/square/dark/gemini.png",
    "wideLogoUrl": "/logos/banner/dark/gemini.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "perplexity",
    "title": "Perplexity AI",
    "category": "utilities",
    "url": "https://www.perplexity.ai",
    "customFullscreenUrl": "",
    "icon": "search",
    "brandSlug": "perplexity",
    "customLogoUrl": "/logos/square/dark/perplexity.png",
    "wideLogoUrl": "/logos/banner/dark/perplexity.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "deepseek",
    "title": "DeepSeek AI",
    "category": "utilities",
    "url": "https://chat.deepseek.com",
    "customFullscreenUrl": "",
    "icon": "bot",
    "brandSlug": "deepseek",
    "customLogoUrl": "/logos/square/dark/deepseek.png",
    "wideLogoUrl": "/logos/banner/dark/deepseek.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "duckduckgo",
    "title": "DuckDuckGo",
    "category": "utilities",
    "url": "https://duckduckgo.com",
    "customFullscreenUrl": "",
    "icon": "search",
    "brandSlug": "duckduckgo",
    "customLogoUrl": "/logos/square/dark/duckduckgo.png",
    "wideLogoUrl": "/logos/banner/dark/duckduckgo.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "chess",
    "title": "Chess.com",
    "category": "games",
    "url": "https://www.chess.com",
    "customFullscreenUrl": "",
    "icon": "gamepad-2",
    "brandSlug": "chess",
    "customLogoUrl": "/logos/square/dark/chess.png",
    "wideLogoUrl": "/logos/banner/dark/chess.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "geoguessr",
    "title": "GeoGuessr",
    "category": "games",
    "url": "https://www.geoguessr.com",
    "customFullscreenUrl": "",
    "icon": "compass",
    "brandSlug": "geoguessr",
    "customLogoUrl": "/logos/square/dark/geoguessr.png",
    "wideLogoUrl": "/logos/banner/dark/geoguessr.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "lichess",
    "title": "Lichess",
    "category": "games",
    "url": "https://lichess.org",
    "customFullscreenUrl": "",
    "icon": "gamepad-2",
    "brandSlug": "lichess",
    "customLogoUrl": "/logos/square/dark/lichess.png",
    "wideLogoUrl": "/logos/banner/dark/lichess.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "xbox",
    "title": "Xbox Cloud Gaming",
    "category": "games",
    "url": "https://www.xbox.com/play",
    "customFullscreenUrl": "",
    "icon": "gamepad-2",
    "brandSlug": "xbox",
    "customLogoUrl": "/logos/square/dark/xbox.png",
    "wideLogoUrl": "/logos/banner/dark/xbox.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "geforce",
    "title": "GeForce NOW",
    "category": "games",
    "url": "https://play.geforcenow.com",
    "customFullscreenUrl": "",
    "icon": "monitor",
    "brandSlug": "geforce",
    "customLogoUrl": "/logos/square/dark/geforce.png",
    "wideLogoUrl": "/logos/banner/dark/geforce.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "emulatorjs",
    "title": "EmulatorJS (Retro Games)",
    "category": "games",
    "url": "https://emulatorjs.org",
    "customFullscreenUrl": "",
    "icon": "gamepad-2",
    "brandSlug": "emulatorjs",
    "customLogoUrl": "/logos/square/dark/emulatorjs.png",
    "wideLogoUrl": "/logos/banner/dark/emulatorjs.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "game2048",
    "title": "2048 Game",
    "category": "games",
    "url": "https://play2048.co",
    "customFullscreenUrl": "",
    "icon": "grid",
    "brandSlug": "game2048",
    "customLogoUrl": "/logos/square/dark/game2048.png",
    "wideLogoUrl": "/logos/banner/dark/game2048.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "wordle",
    "title": "Wordle",
    "category": "games",
    "url": "https://www.nytimes.com/games/wordle",
    "customFullscreenUrl": "",
    "icon": "type",
    "brandSlug": "wordle",
    "customLogoUrl": "/logos/square/dark/wordle.png",
    "wideLogoUrl": "/logos/banner/dark/wordle.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "krunker",
    "title": "Krunker.io",
    "category": "games",
    "url": "https://krunker.io",
    "customFullscreenUrl": "",
    "icon": "crosshair",
    "brandSlug": "krunker",
    "customLogoUrl": "/logos/square/dark/krunker.png",
    "wideLogoUrl": "/logos/banner/dark/krunker.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "pornhub",
    "title": "Pornhub",
    "category": "vm18",
    "url": "https://www.pornhub.com",
    "customFullscreenUrl": "",
    "icon": "lock",
    "brandSlug": "pornhub",
    "customLogoUrl": "/logos/square/dark/pornhub.png",
    "wideLogoUrl": "/logos/banner/dark/pornhub.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "xvideos",
    "title": "XVideos",
    "category": "vm18",
    "url": "https://www.xvideos.com",
    "customFullscreenUrl": "",
    "icon": "lock",
    "brandSlug": "xvideos",
    "customLogoUrl": "/logos/square/dark/xvideos.png",
    "wideLogoUrl": "/logos/banner/dark/xvideos.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "xhamster",
    "title": "xHamster",
    "category": "vm18",
    "url": "https://xhamster.com",
    "customFullscreenUrl": "",
    "icon": "lock",
    "brandSlug": "xhamster",
    "customLogoUrl": "/logos/square/dark/xhamster.png",
    "wideLogoUrl": "/logos/banner/dark/xhamster.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "onlyfans",
    "title": "OnlyFans",
    "category": "vm18",
    "url": "https://onlyfans.com",
    "customFullscreenUrl": "",
    "icon": "lock",
    "brandSlug": "onlyfans",
    "customLogoUrl": "/logos/square/dark/onlyfans.png",
    "wideLogoUrl": "/logos/banner/dark/onlyfans.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "redtube",
    "title": "RedTube",
    "category": "vm18",
    "url": "https://www.redtube.com",
    "customFullscreenUrl": "",
    "icon": "lock",
    "brandSlug": "redtube",
    "customLogoUrl": "/logos/square/dark/redtube.png",
    "wideLogoUrl": "/logos/banner/dark/redtube.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "youporn",
    "title": "YouPorn",
    "category": "vm18",
    "url": "https://www.youporn.com",
    "customFullscreenUrl": "",
    "icon": "lock",
    "brandSlug": "youporn",
    "customLogoUrl": "/logos/square/dark/youporn.png",
    "wideLogoUrl": "/logos/banner/dark/youporn.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "chaturbate",
    "title": "Chaturbate",
    "category": "vm18",
    "url": "https://chaturbate.com",
    "customFullscreenUrl": "",
    "icon": "lock",
    "brandSlug": "chaturbate",
    "customLogoUrl": "/logos/square/dark/chaturbate.png",
    "wideLogoUrl": "/logos/banner/dark/chaturbate.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "spotify-lyrics",
    "title": "Spotify Lyrics Viewer",
    "category": "smarthome",
    "url": "https://spotify-lyrics-viewer.nitratine.net/",
    "customFullscreenUrl": "",
    "icon": "music",
    "brandSlug": "spotify-lyrics",
    "customLogoUrl": "/logos/square/dark/spotify-lyrics.png",
    "wideLogoUrl": "/logos/banner/dark/spotify-lyrics.png",
    "iconColor": "#ffffff",
    "bgColor": "#ffffff",
    "isSystem": true
  },
  {
    "id": "grafana",
    "title": "Grafana",
    "category": "smarthome",
    "url": "http://localhost:3000",
    "customFullscreenUrl": "",
    "icon": "activity",
    "brandSlug": "grafana",
    "customLogoUrl": "/logos/square/dark/grafana.png",
    "wideLogoUrl": "/logos/banner/dark/grafana.png",
    "iconColor": "#ffffff",
    "bgColor": "#F46800",
    "isSystem": true
  },
  {
    "id": "f1tv",
    "title": "F1 TV",
    "category": "sports",
    "url": "https://f1tv.formula1.com",
    "customFullscreenUrl": "",
    "icon": "flag",
    "brandSlug": "f1tv",
    "customLogoUrl": "/logos/square/dark/f1tv.png",
    "wideLogoUrl": "/logos/banner/dark/f1tv.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "eurosport",
    "title": "Eurosport",
    "category": "sports",
    "url": "https://www.eurosport.com",
    "customFullscreenUrl": "",
    "icon": "trophy",
    "brandSlug": "eurosport",
    "customLogoUrl": "/logos/square/dark/eurosport.png",
    "wideLogoUrl": "/logos/banner/dark/eurosport.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "espn",
    "title": "ESPN",
    "category": "sports",
    "url": "https://www.espn.com",
    "customFullscreenUrl": "",
    "icon": "activity",
    "brandSlug": "espn",
    "customLogoUrl": "/logos/square/dark/espn.png",
    "wideLogoUrl": "/logos/banner/dark/espn.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "motogp",
    "title": "MotoGP",
    "category": "sports",
    "url": "https://www.motogp.com",
    "customFullscreenUrl": "",
    "icon": "zap",
    "brandSlug": "motogp",
    "customLogoUrl": "/logos/square/dark/motogp.png",
    "wideLogoUrl": "/logos/banner/dark/motogp.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "flashscore",
    "title": "Flashscore (Diretta)",
    "category": "sports",
    "url": "https://www.flashscore.com",
    "customFullscreenUrl": "",
    "icon": "activity",
    "brandSlug": "flashscore",
    "customLogoUrl": "/logos/square/dark/flashscore.png",
    "wideLogoUrl": "/logos/banner/dark/flashscore.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "nba",
    "title": "NBA",
    "category": "sports",
    "url": "https://www.nba.com",
    "customFullscreenUrl": "",
    "icon": "dribbble",
    "brandSlug": "nba",
    "customLogoUrl": "/logos/square/dark/nba.png",
    "wideLogoUrl": "/logos/banner/dark/nba.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "redbulltv",
    "title": "Red Bull TV",
    "category": "sports",
    "url": "https://www.redbull.com/tv",
    "customFullscreenUrl": "",
    "icon": "tv",
    "brandSlug": "redbulltv",
    "customLogoUrl": "/logos/square/dark/redbulltv.png",
    "wideLogoUrl": "/logos/banner/dark/redbulltv.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "strava",
    "title": "Strava",
    "category": "sports",
    "url": "https://www.strava.com",
    "customFullscreenUrl": "",
    "icon": "activity",
    "brandSlug": "strava",
    "customLogoUrl": "/logos/square/dark/strava.png",
    "wideLogoUrl": "/logos/banner/dark/strava.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "wwe",
    "title": "WWE Network",
    "category": "sports",
    "url": "https://www.wwe.com",
    "customFullscreenUrl": "",
    "icon": "trophy",
    "brandSlug": "wwe",
    "customLogoUrl": "/logos/square/dark/wwe.png",
    "wideLogoUrl": "/logos/banner/dark/wwe.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "uefatv",
    "title": "UEFA.tv",
    "category": "sports",
    "url": "https://www.uefa.tv",
    "customFullscreenUrl": "",
    "icon": "trophy",
    "brandSlug": "uefatv",
    "customLogoUrl": "/logos/square/dark/uefatv.png",
    "wideLogoUrl": "/logos/banner/dark/uefatv.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "sofascore",
    "title": "SofaScore",
    "category": "sports",
    "url": "https://www.sofascore.com",
    "customFullscreenUrl": "",
    "icon": "activity",
    "brandSlug": "sofascore",
    "customLogoUrl": "/logos/square/dark/sofascore.png",
    "wideLogoUrl": "/logos/banner/dark/sofascore.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  },
  {
    "id": "nfl",
    "title": "NFL",
    "category": "sports",
    "url": "https://www.nfl.com",
    "customFullscreenUrl": "",
    "icon": "shield",
    "brandSlug": "nfl",
    "customLogoUrl": "/logos/square/dark/nfl.png",
    "wideLogoUrl": "/logos/banner/dark/nfl.png",
    "iconColor": "#ffffff",
    "bgColor": "transparent",
    "isSystem": true
  }
];
